export default __webpack_public_path__ + "img/fdf6ed583f82dcda3bd92fdc6d03f75d.png";